import React from 'react'
import { Link } from 'react-router-dom'
import { Routes } from '../../constants/RouteConstants'

const PaymentSuccess = () => {
    return (
        <main id="main-content" className="d-flex align-items-center justify-content-center h-100">
            <div className="text-center">
                <div className='success-tick'>
                    <svg width="100" height="100" viewBox="0 0 100 100" aria-hidden="true">
                        <circle
                            fill="none"
                            stroke="#68E534"
                            strokeWidth="9"
                            cx="50"
                            cy="50"
                            r="45"
                            strokeLinecap="round"
                            transform="rotate(-90 50 50)"
                            className="circle"
                        />
                        <polyline
                            fill="none"
                            stroke="#68E534"
                            points="22,53 43,71 76,34"
                            strokeWidth="9"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="tick"
                        />
                    </svg>
                </div>

                <h1 className='mt-4 mb-5 fs-4'>Payment Successful!</h1>

                <div className='mt-3'>
                    <Link to={Routes?.Subscription} className='com-btn px-3' >
                        Continue
                    </Link>
                </div>
            </div>
        </main>
    )
}

export default PaymentSuccess